import { Inject, Injectable } from '@angular/core';

import { LabeledEnumValue, NumberingFormatAutotext } from '@skylab-shared/dataModel';

import { EnumTranslator, EnumTranslatorBase, L10n, L10nBase } from '@skylab-angular-shared/core';
import { BadgeTextPipe } from '@skylab-angular-shared/pipes';

@Injectable({
    providedIn: 'root'
})
export class NumberingsFormatsPopupService {
    public numberingFormats: LabeledEnumValue[];
    public numberingFormatsPlaceholders = {
        [NumberingFormatAutotext.Day]: ['[D]', '[DD]'],
        [NumberingFormatAutotext.Month]: ['[M]', '[MM]'],
        [NumberingFormatAutotext.Year]: ['[RR]', '[RRRR]'],
        [NumberingFormatAutotext.Number]: ['[Numer]']
    };

    private autotextTagRegExp = new RegExp(/\[\w*\]/g);

    public constructor(
        @Inject(EnumTranslator) private readonly enumTranslator: EnumTranslatorBase,
        @Inject(L10n) private readonly l10n: L10nBase,
        private badgeTextPipe: BadgeTextPipe
    ) {
        this.numberingFormats = this.enumTranslator.getLabeledEnumValueArray(NumberingFormatAutotext);
    }

    public getFormattedContent(): string {
        const rawContent = this.getRawContent();
        const joinTag = this.l10n._T('shared.scenes.numbering-formats.join-tag');

        return (`
            <ul class="numbering-format__list">
                ${rawContent.map(item => {
                    return `<li>${this.badgeTextPipe.transform(`${this.numberingFormatsPlaceholders[item.value as NumberingFormatAutotext].join(` ${joinTag} `)} - ${item.label}`, this.autotextTagRegExp)}</li>`;
                }).join('')}
            </ul>
        `);
    }

    public getRawContent(): LabeledEnumValue[] {
        return this.enumTranslator.getLabeledEnumValueArray(NumberingFormatAutotext);
    }
}
